import { https } from "../http";
import store from "../store";

import { setLoading, setMedications } from "../store/reducers/medication";
import { decrypt, showError } from "../utils/index";

// GET
const getMedications = async (page, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(`/medication/?page=${page}`);

    if (response?.status === 200) {
      let decrypted = decrypt(response?.data?.data);
      store.dispatch(setMedications(decrypted));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const scanMedicationLabel = async (file) => {
  const formData = new FormData();
  formData.append("image", file);
  const response = await https().post("/medication/scan-ocr", formData);
  return response?.data?.data;
};

export { getMedications, scanMedicationLabel };
